module.exports = __webpack_public_path__ + "img/new-banner.0cee1ea.png";